import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';
const green = '#508b46';
const blue = '#006cfc';
export const useStyles = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      background: '#f7f8f8',
      minHeight: '95px !important',
      height: '350px',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '& .MuiCardContent-root': {
        padding: 0,
      },
      '&.disabled': {
        opacity: 0.5,
      },
    },
    infoIcon: {
      fontSize: '20px',
      marginBottom: theme.spacing(-0.8),
      marginInlineStart: theme.spacing(1),
      color: theme.palette.grey[800],
      cursor: 'pointer',
    },
    content: {
      position: 'relative',
      paddingBottom: `${theme.spacing(0.5)} !important`,
      '&.disabled': {
      },
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
      flex: '2',
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
    },
    subtitleText: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
      paddingBottom: theme.spacing(1.5),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
      marginInlineEnd: theme.spacing(1),
      borderRadius: 8,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      backgroundColor: '#ffffff',
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,
      color: '#697277',
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      justifyContent: 'flex-end',
      display: 'flex',
      flex: '3',
      fontSize: '10px',
    },
    typePlan: {
      marginRight: '16px',
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
      cursor: 'pointer',
      '&:hover p': {
        color: theme.palette.primary.main,
      },
      '&.disabled': {
        cursor: 'auto',
        '&:hover p': {
          color: 'initial',
        },
      },
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
    cardHeader: {
      padding: '4px 16px',
      borderBottom: `1px solid #d8d1d1`,
    },
    cardInside: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    textCenter: {
      textAlign: 'center',
    },
    expiredFlag: {
      background: ligherGray,
      borderBottomLeftRadius: 10,
      padding: theme.spacing(1, 2),
      paddingBottom: theme.spacing(1.5),

      color: '#455b64',
      fontSize: 13,
      position: 'absolute',
      right: 0,
      top: 0,
      fontWeight: 'bold',
    },
    blockedAmount: {
      display: 'flex',
      color: '#263238',
      fontSize: 12,
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
    },
    amountPaid: {
      margin: '0 16px',
      color: '#1879fa',
      cursor: 'pointer',
    },
    blockedAmountIcon: {
      color: '#263238',
      fontSize: 16,
      fontWeight: 'normal',
      marginBottom: -5,
      marginInlineEnd: theme.spacing(0.5),

    },
    boxChart: {
      display: 'flex',
      width: '100%',
      height: '100px',
      justifyContent: 'space-around',
      cursor: 'default',
      '& > div': {
        width: '110px',
        flexWrap: 'wrap',
        alignContent: 'center',
      },
    },
    messagePercent: {
      textAlign: 'center',
      '& < div': {
        marginTop: '0 !important',
      },
    },
    blueColor: {
      color: '#3870ba !important',
      fontSize: '14px',
      fontWeight: 'bold',
    },
    blueLight: {
      color: '#006cfc !important',
      fontSize: '14px',
      fontWeight: 'bold',
    },
    textProgress: {
      fontSize: '10px',
      color: '#6072b4',
    },
    grayColor: {
      color: '#697277',
      fontWeight: 'bold',
    },
    grayLight: {
      color: '#9892d6',
    },
  };
});
